import AuthorItem from "@app/components/author-item";
import { RoutePath } from "@app/constants";
import { Author } from "@app/types";
import { Images } from "@assets/images";
import { useNavigate } from "react-router-dom";

type FeaturedAuthorProps = {
  authors: Author[];
};

function FeaturedAuthor({ authors }: FeaturedAuthorProps) {
  const navigate = useNavigate();

  const handleDiscoveryClick = () => {
    navigate(RoutePath.AUTHOR);
  };

  const handleItemClick = (authorId: number) => {
    navigate(`${RoutePath.AUTHOR}/${authorId}`);
  };

  return (
    <div>
      <div className="flex justify-between items-center mt-10">
        <div className="text-[#171A20] font-bold text-[26px]">
          Tác Giả Nổi Bật
        </div>
        <div
          className="text-[#38499b] text-sm font-semibold cursor-pointer flex items-center"
          onClick={handleDiscoveryClick}
        >
          Khám phá
          <img className="inline ml-2" src={Images.ArrowRight.default} alt="" />
        </div>
      </div>
      <div className="mt-3 overflow-x-auto scroll-smooth">
        <div className="flex gap-6">
          {authors.map((item) => (
            <div
              key={item.id}
              className="cursor-pointer"
              onClick={() => handleItemClick(item.id)}
            >
              <AuthorItem author={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FeaturedAuthor;
